module.exports = __webpack_public_path__ + "img/awards_image_08.d47feee2.jpg";